import * as React from 'react';


export default function(props) {
  return (
    <div>
      Please wait...
    </div>
  );
};
